import { ApplicationConfig, importProvidersFrom, provideZoneChangeDetection, APP_INITIALIZER } from '@angular/core';
import { provideRouter, withInMemoryScrolling } from '@angular/router';
import { provideHttpClient, withInterceptors } from '@angular/common/http';
import { Title } from '@angular/platform-browser';
import { routes } from './app.route';
import { provideStore } from '@ngrx/store';
import { indexReducer } from './store/index.reducer';
import { TranslateLoader, TranslateModule } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { HttpClient } from '@angular/common/http';
import { provideEchartsCore } from 'ngx-echarts';
import { BarChart, LineChart, PieChart } from 'echarts/charts';
import { GridComponent, LegendComponent, TitleComponent, TooltipComponent } from 'echarts/components';
import { CanvasRenderer } from 'echarts/renderers';
import * as echarts from 'echarts/core';
import { provideLottieOptions } from 'ngx-lottie';
import player from 'lottie-web';
import { AppService } from './core/service/app.service';
import { LoadingInterceptor } from './core/interceptor/loading.interceptor';
import { authInterceptor } from './core/interceptor/auth.interceptor';
import { fileSizeInterceptor } from './core/interceptor/file-size.interceptor';
import { provideAnimations } from '@angular/platform-browser/animations';
import { CustomTranslateHttpLoader } from './core/service/custom-translate-http-loader.service';
import { provideToastr } from 'ngx-toastr';
import { PermissionService } from './core/service/permission.service';

export function permissionsInitializer(permissionService: PermissionService) {
    return () => permissionService.loadPermissions();
}

export function httpTranslateLoader(http: HttpClient) {
    return new TranslateHttpLoader(http, '../i18n/components-translation/user/', '.json');
}

echarts.use([LineChart, BarChart, PieChart, GridComponent, TooltipComponent, LegendComponent, TitleComponent, CanvasRenderer]);

export const provideTranslation = () => ({
    defaultLanguage: 'en',
    loader: {
        provide: TranslateLoader,
        useFactory: HttpLoaderFactory,
        deps: [HttpClient],
    },
});

export function HttpLoaderFactory(http: HttpClient) {
    return new CustomTranslateHttpLoader(http);
}

export const appConfig: ApplicationConfig = {
    providers: [
        provideAnimations(),
        provideZoneChangeDetection({ eventCoalescing: true }),
        provideRouter(routes, withInMemoryScrolling({ scrollPositionRestoration: 'enabled' })),
        provideToastr({
            timeOut: 3000,
            positionClass: 'toast-top-right',
            preventDuplicates: true,
            closeButton: true,
            progressBar: true,
        }),
        provideHttpClient(withInterceptors([LoadingInterceptor, authInterceptor, fileSizeInterceptor])),
        Title,
        AppService,
        importProvidersFrom([TranslateModule.forRoot(provideTranslation())]),
        provideStore({ index: indexReducer }),
        provideEchartsCore({ echarts: () => import('echarts/core') }),
        provideLottieOptions({
            player: () => player,
        }),
        {
            provide: APP_INITIALIZER,
            useFactory: permissionsInitializer,
            deps: [PermissionService],
            multi: true,
        },
    ],
};
